import React from "react";
import "../styles/DynamicCard.css";
import { FaDownload } from "react-icons/fa";
import { IconType } from "react-icons";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

interface DynamicCardProps {
  title: string;
  data: { label: string; value: string | number; icon?: IconType; color?: string }[];
  onDownload?: () => void;
  showChart?: boolean;
  chartType?: "pie";
}

const DynamicCard: React.FC<DynamicCardProps> = ({ 
  title, 
  data, 
  onDownload,
  showChart = false,
  chartType = "pie"
}) => {
  const domaines: { icon: IconType }[] = [{ icon: FaDownload }];

  const defaultColors = ["#0d6efd", "#dc3545", "#ffc107", "#198754", "#6c757d"];

  const chartData = data.map((item, index) => ({
    name: item.label,
    value: typeof item.value === "string" ? parseFloat(item.value) || 0 : item.value,
    color: item.color || defaultColors[index % defaultColors.length]
  }));

  // --- Texte à l'intérieur du camembert ---
  const renderLabelInside = (props: any) => {
    const { cx, cy, midAngle, innerRadius, outerRadius, index } = props;
    const radius = innerRadius + (outerRadius - innerRadius) / 2;
    const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
    const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
    const value = chartData[index].value;

    return (
      <text
        x={x}
        y={y}
        className="chart-value"
        textAnchor="middle"
        dominantBaseline="central"
      >
        {value}
      </text>
    );
  };

  return (
    <div className="dynamic-card">
      <div className="dynamic-card-header">
        <h4 className="title">{title}</h4>
        {domaines.map((d, i) => {
          const Icon = d.icon as React.ComponentType<{ className?: string }>;
          return (
            <button
              key={i}
              className="download-btn"
              onClick={onDownload}
              title="Télécharger"
            >
              <Icon />
            </button>
          );
        })}
      </div>

      <div className="dynamic-card-body">
        {showChart ? (
          <div className="chart-layout">
            <div className="chart-container" style={{ width: "100%", height: 250 }}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={chartData}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={renderLabelInside}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                    stroke="none"
                  >
                    {chartData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} stroke="none" />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>

            <div className="chart-legend">
              {data.map((item, index) => (
                <div key={`legend-${index}`} className="legend-item">
                  <span
                    className="legend-color"
                    style={{ backgroundColor: chartData[index].color }}
                  />
                  <span className="legend-label">{item.label}</span>
                  <span className="legend-value">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className="dynamic-card-row labels">
              {data.map((item, index) => (
                <div key={`label-${index}`} className="dynamic-card-col">
                  {item.label}
                </div>
              ))}
            </div>

            <div className="dynamic-card-row values">
              {data.map((item, index) => (
                <div key={`value-${index}`} className="dynamic-card-col">
                  {item.value}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DynamicCard;
